import { render, staticRenderFns } from "./AccountOrders.vue?vue&type=template&id=8a2d5448&"
import script from "./AccountOrders.vue?vue&type=script&lang=js&"
export * from "./AccountOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports